import {CALL_API} from 'redux-api-middleware';
import {
  API_ALL_TOGGLES_REQUEST,
  API_ALL_TOGGLES_SUCCESS,
  API_ALL_TOGGLES_FAILURE,
} from 'common/types';
import {ENDPOINT_TOGGLE} from 'common/endpoints';

export default {
  getAllToggles: () => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_TOGGLE,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        types: [
          API_ALL_TOGGLES_REQUEST,
          API_ALL_TOGGLES_SUCCESS,
          API_ALL_TOGGLES_FAILURE,
        ],
      },
    };
  },
};
